// Init
import React from 'react';

// Importing Components
import Header from '../components/Header';
import HeroSection from '../components/Hero-section';
import ProjectSection from '../components/projects_section';
import SpringDetails from '../components/Springs-design';
import HelpYou from '../components/HelpYou';
import Worktogether from '../components/Worktogether';
import MySlider from '../components/myslider';
import Footer from '../components/Footer';

// Home Component
export default function Home() {
  return (
    <div>
      <Header />
      <section id="HeroSection">
        <HeroSection />
      </section>
      <section id="ProjectSection">
        <ProjectSection />
      </section>
      <section id="SpringDetails">
        <SpringDetails />
      </section>
      <HelpYou />
      <section id="Worktogether">
        <Worktogether />
      </section>
      <MySlider />
      <Footer />
    </div>
  );
}
